function getAcademyLessonVideoPreviewImgSrcByUrl(url: string): string {
    if (!url) return '';

    if (url.includes('youtube.com')) {
        const videoId = url.split('v=')[1];
        return `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`;
    } else {
        return ''
    }
}

export default getAcademyLessonVideoPreviewImgSrcByUrl;
